import authentication from "@irati/auth"

export function hasPayrollPay(): boolean {
  const {benefits} = authentication.apps()

  if (
    !!benefits?.he &&
    !!benefits?.ctw &&
    !!benefits?.alp &&
    !!benefits?.pa &&
    !!benefits?.cs &&
    !!benefits?.tal &&
    !!benefits?.gm &&
    !!benefits?.sf &&
    !!benefits?.pg &&
    !!benefits?.hcp
  ) {
    return true
  }
  return false
}
